import { stringToSVG } from 'utilities';

import iconNames from './icon-names';

import AddIconString from 'assets/images/add-icon.svg?raw';
import ExportIconString from 'assets/images/export-icon.svg?raw';
import GearIconString from 'assets/images/gear-icon.svg?raw';
import downArrowIconString from 'assets/images/down-arrow.svg?raw';
import rightArrowIconString from 'assets/images/right-arrow-icon.svg?raw';

const addIcon = stringToSVG(AddIconString);
const exportIcon = stringToSVG(ExportIconString);
const gearIcon = stringToSVG(GearIconString);
const downArrowIcon = stringToSVG(downArrowIconString);
const rightArrowIcon = stringToSVG(rightArrowIconString);

export function getIconByName(name) {

  if (name === iconNames.ADD) {
    return addIcon.cloneNode(true);
  }

  if (name === iconNames.EXPORT) {
    return exportIcon.cloneNode(true);
  }

  if (name === iconNames.GEAR) {
    return gearIcon.cloneNode(true);
  }

  if (name === iconNames.DOWN_ARROW) {
    return downArrowIcon.cloneNode(true);
  }

  if (name === iconNames.LEFT_ARROW) {
    return rightArrowIcon.cloneNode(true);
  }

  return addIcon.cloneNode(true);

}

export function buildButtonAttributes(options) {

  const attributes = {
    type: 'button',
    class: 'second-level-cta ' + (options.class || ''),
    onclick: options.onClick,
    disabled: options.disabled
  };

  if (typeof options.id === 'string') {
    attributes.id = options.id;
  }

  return attributes;

}